import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Permission } from '../../models/permission.model';
import { Role } from '../../models/role.model';
import { UserEdit } from '../../models/user-edit.model';
import { User } from '../../models/user.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { AuthService } from '../../services/auth.service';
import { Utilities } from '../../services/utilities';
import { Subscription } from 'rxjs';

@Component({
    selector: 'personalsettings',
    template: require('./personalsettings.component.html'),
    styles: [require('./personalsettings.component.css')],
    animations: [fadeInOut]
})
export class PersonalSettingsComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];
    mode: string = "Bewerk";
    user: User = new User;
    userEdit: UserEdit = new UserEdit;
    loading: boolean = false;
    allRoles: Role[] = [];
    rrole: Role[] = [];
    selectedData: any;
    registerType: string;
    ddRegisterTypes: string[] = [];

    constructor(private userService: AccountService, private activatedRoute: ActivatedRoute,
        private alertService: AlertService, private ngxLogger: NGXLogger, private authService: AuthService) { }

    ngOnInit() {
        this.ddRegisterTypes.push('Bedrijf');
        this.ddRegisterTypes.push('Particulier');
        this.registerType = 'Bedrijf';

        this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.userEdit.Id = params['id'];
                this.mode = "Bewerk";
                this.getById();
            }
        });
        this.getRoles();
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    reloadAll() {
        const paramSubscriber = this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.userEdit.Id = params['id'];
                this.mode = "Bewerk";
                this.getById();
            }
        });
        this.getRoles();
        this.subscribers.push(paramSubscriber);
    }

    getRoles() {
        const rolesSubscriber = this.userService.getRoles().subscribe(response => {
            this.allRoles = response;
            this.rrole = this.allRoles;
            if (this.mode == "Toevoegen") {
                this.userEdit.RoleId = this.rrole[0].Name;
            }
            if (this.authService.currentUser && this.rrole && this.rrole.length > 0) {
                this.rrole = this.allRoles.filter(f => f.Name === this.authService.currentUser.RoleId);
            }
        });
        this.subscribers.push(rolesSubscriber);
    }

    createUpdate(form: NgForm) {
        this.userEdit.UserName = this.userEdit.Email;
        this.userEdit.Email = this.userEdit.Customer.Email;

        if (this.registerType === 'Particulier') {
            this.userEdit.Customer.Company = null;
            this.userEdit.Customer.BTW = null;
        }
        if (form.valid) {
            const upSubscriber = this.userService.updateUser(this.userEdit).subscribe(user => {
                this.alertService.showMessage('Gebruiker', 'Gebruiker met succes bewaard!', MessageSeverity.success);
                form.resetForm();
                this.reloadAll();
            }, error => {
                const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
                if (errorMessage == 'Email Exists') {
                    this.alertService.showMessage(this.userEdit.Email, 'bestaat al!', MessageSeverity.error);
                } else if (errorMessage == 'BTW Exists') {
                    this.alertService.showMessage(this.userEdit.Customer.BTW, 'bestaat al!', MessageSeverity.error);
                } else {
                    this.alertService.showStickyMessage('Fout', 'Er is iets fout gegaan', MessageSeverity.error);
                }
            });
            this.subscribers.push(upSubscriber);
        }
    }

    changePassword(userId?: string, newPassword?: string, confirmPassword?: string, form?: NgForm) {
        if (newPassword !== undefined && confirmPassword !== undefined) {
            if (newPassword !== confirmPassword) {
                this.alertService.showMessage("Persoonlijke Instellingen", 'Nieuw wachtwoord en wachtwoord bevestigen komen niet overeen.', MessageSeverity.error);
            } else {
                const upPswdSubscriber = this.userService.getUserUpdatePassword(userId, newPassword).subscribe(user => {
                    this.alertService.showMessage("Persoonlijke Instellingen", 'Je wachtwoord is met succes veranderd!', MessageSeverity.success);
                    this.userEdit.confirmPassword = '';
                    this.userEdit.newPassword = '';
                    form.resetForm();
                    this.reloadAll();
                });
                this.subscribers.push(upPswdSubscriber);
            }
        } else {
            if (newPassword === undefined || confirmPassword === undefined) {
                this.alertService.showMessage("Persoonlijke Instellingen", 'Nieuw wachtwoord en wachtwoord bevestigen mogen niet leeg zijn.', MessageSeverity.error);
            } else {
                if (newPassword !== confirmPassword) {
                    this.alertService.showMessage("Persoonlijke Instellingen", 'Nieuw wachtwoord en wachtwoord bevestigen komen niet overeen.', MessageSeverity.error);
                }
            }
        }
    }

    getById() {
        this.loading = true;
        const userSubscriber = this.userService.getUser(this.activatedRoute.snapshot.params["id"]).subscribe((res: UserEdit) => {
            this.userEdit = res;
            this.loading = false;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(userSubscriber);
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    get canaddUsersPermission() {
        return this.userService.userHasPermission(Permission.addUsersPermission);
    }

    get caneditUsersPermission() {
        return this.userService.userHasPermission(Permission.editUsersPermission);
    }

    get canapproveUsersPermission() {
        return this.userService.userHasPermission(Permission.approveUsersPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/personalsettings/personalsettings.component.ts